<template>
  <section class="stories mt-8 md:mt-10">
    <p
      class="text-[22px] leading-normal sm:text-[40px] sm:leading-[50px] text-black-900 font-medium mb-5"
    >
      Other Stories of Kindness
    </p>
    <div
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14"
    >
      <template v-if="isLoading">
        <div v-for="i in 3" :key="i" class="flex flex-col gap-4">
          <UtilsSkeletonLoading class="w-full h-40" />
          <UtilsSkeletonLoading class="w-1/2 h-10" />
          <UtilsSkeletonLoading class="w-full h-16" />
        </div>
      </template>
      <template v-else-if="data.data.length === 0">
        <p class="text-base text-bw-900">No related sustainability found</p>
      </template>
      <template v-else>
        <ArticleCard
          v-for="related in data.data"
          :key="related.id"
          :with-logo="false"
          :title="related.attributes?.card_title"
          :desc="related.attributes?.layout_component?.[0]?.description"
          :image-url="
            related.attributes?.image?.data?.attributes?.formats?.medium?.url ||
            related.attributes?.image?.data?.attributes?.url ||
            '/assets/img/404.png'
          "
          :slug="`/sustainability/${related.attributes?.slug}`"
          :is-title-paragraph="true"
        />
      </template>
    </div>
  </section>
</template>

<script setup>
// VARIABLE DECLARATION
const isLoading = ref(true)

// PROPS
const props = defineProps({
  detailId: {
    type: Number,
    default: 1
  },
  typeId: {
    type: Number,
    required: true
  }
})

const query = {
  'filters[$and][0][layout][$eq]': 'sustainability',
  'filters[$and][1][id][$ne]': props.detailId,
  'pagination[pageSize]': 3,
  populate: 'image,layout_component,layout_component.type,sustainability_type',
  sort: 'publish_at:desc'
}

// METHODS
const { data, pending } = await useSuitmediaApiData(`/api/contents`, {
  query
})
isLoading.value = pending.value
</script>

<style lang="scss" scoped></style>
